export default __webpack_public_path__ + "static/media/151-picket.66311de9.png";